import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthProvider';

export function LoadingScreen({ label = '불러오는 중이에요…' }: { label?: string }) {
  return (
    <div className="pf-page pf-center">
      <div className="pf-spinner" aria-hidden="true" />
      <p className="pf-muted">{label}</p>
    </div>
  );
}

export function MemberMissingScreen() {
  const { signOut } = useAuth();
  return (
    <div className="pf-page pf-center">
      <div className="pf-status-icon" aria-hidden="true">
        <i className="ri-error-warning-line" />
      </div>
      <h1>회원 정보를 찾을 수 없어요</h1>
      <p className="pf-muted">
        계정 정보가 올바르지 않아요. 로그아웃 후 다시 시도해 주세요.
      </p>
      <button type="button" className="pf-btn primary" onClick={() => void signOut()}>
        <i className="ri-logout-box-r-line" aria-hidden="true" />
        로그아웃
      </button>
    </div>
  );
}

/* A logged-in member whose account has been approved by the operator. */
export function RequireApprovedMember({ children }: { children: ReactNode }) {
  const { loading, memberLoading, session, member } = useAuth();

  if (loading || memberLoading) return <LoadingScreen />;
  if (!session) return <Navigate to="/login" replace />;
  if (!member) return <MemberMissingScreen />;
  if (member.role === 'admin') return <Navigate to="/admin" replace />;
  if (member.status !== 'approved') return <Navigate to="/pending" replace />;
  return <>{children}</>;
}

/* The operator (admin) only. */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { loading, memberLoading, session, member } = useAuth();

  if (loading || memberLoading) return <LoadingScreen />;
  if (!session) return <Navigate to="/login" replace />;
  if (!member) return <MemberMissingScreen />;
  if (member.role !== 'admin') return <Navigate to="/my" replace />;
  return <>{children}</>;
}